module.exports = __webpack_public_path__ + "static/media/score-bad.71aeeda0.svg";